// FILE: src/api/adminFinanceApi.js
import { adminJson } from "./adminHttp";

function enc(v) {
  return encodeURIComponent(String(v ?? ""));
}

function getAdminMe() {
  try {
    const raw = localStorage.getItem("admin_me");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function withAdminId(path) {
  const me = getAdminMe();
  const adminId = me?.id;
  if (!adminId) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}adminId=${enc(adminId)}`;
}

export async function financeListPayments({
  q,
  status,
  from, // ISO instant string
  to,   // ISO instant string (exclusive)
  page = 0,
  size = 50,
} = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (status) params.set("status", status);
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  params.set("page", String(page));
  params.set("size", String(size));

  const url = withAdminId(`/admin/finance/payments?${params.toString()}`);
  return adminJson(url);
}

export async function financeGetWalletDashboard({ q } = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  const query = params.toString();
  const url = withAdminId(`/admin/finance/wallet-dashboard${query ? `?${query}` : ""}`);
  return adminJson(url);
}

export async function financeResetOwnerWalletToZero(ownerId, body) {
  const url = withAdminId(`/admin/finance/wallets/${enc(ownerId)}/reset-to-zero`);
  return adminJson(url, {
    method: "POST",
    body: JSON.stringify(body || {}),
  });
}

export async function financeGetPaymentDetail(paymentId) {
  const url = withAdminId(`/admin/finance/payments/${enc(paymentId)}`);
  return adminJson(url);
}

export async function financeListWayrootEarnings({
  q,
  page = 0,
  size = 50,
} = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("page", String(page));
  params.set("size", String(size));

  const url = withAdminId(`/admin/finance/wayroot-earnings?${params.toString()}`);
  return adminJson(url);
}

export async function financeListOwnerPayouts({
  q,
  status,
  eligibleOnly = false,
  page = 0,
  size = 50,
} = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (status && status !== "ALL") params.set("status", status);
  if (eligibleOnly) params.set("eligibleOnly", "true");
  params.set("page", String(page));
  params.set("size", String(size));

  const url = withAdminId(`/admin/finance/owner-payouts?${params.toString()}`);
  return adminJson(url);
}

export async function financeListRefunds({
  q,
  status,
  page = 0,
  size = 50,
} = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (status && status !== "ALL") params.set("status", status);
  params.set("page", String(page));
  params.set("size", String(size));

  const url = withAdminId(`/admin/finance/refunds?${params.toString()}`);
  return adminJson(url);
}

export async function financeUpdateOwnerPayoutStatus(bookingId, body) {
  const url = withAdminId(`/admin/finance/owner-payouts/${enc(bookingId)}/status`);
  return adminJson(url, {
    method: "POST",
    body: JSON.stringify(body || {}),
  });
}

export async function financeListPricingRules() {
  const url = withAdminId(`/admin/finance/pricing-rules`);
  return adminJson(url);
}

export async function financeCreatePricingRule(body) {
  const url = withAdminId(`/admin/finance/pricing-rules`);
  return adminJson(url, {
    method: "POST",
    body: JSON.stringify(body || {}),
  });
}

export async function financeUpdatePricingRule(ruleId, body) {
  const url = withAdminId(`/admin/finance/pricing-rules/${enc(ruleId)}`);
  return adminJson(url, {
    method: "PUT",
    body: JSON.stringify(body || {}),
  });
}

export async function financeListPricingRuleVehicles(ruleId) {
  const url = withAdminId(`/admin/finance/pricing-rules/${enc(ruleId)}/vehicles`);
  return adminJson(url);
}

export async function financeListPlatformFeeConfig() {
  const url = withAdminId(`/admin/finance/platform-fee-config`);
  return adminJson(url);
}

export async function financeUpdatePlatformFeeConfig(mode, body) {
  const url = withAdminId(`/admin/finance/platform-fee-config/${enc(mode)}`);
  return adminJson(url, {
    method: "PUT",
    body: JSON.stringify(body || {}),
  });
}

export async function financeListDatePricing() {
  const url = withAdminId(`/admin/finance/date-pricing`);
  return adminJson(url);
}

export async function financeGetDatePricing(date) {
  const url = withAdminId(`/admin/finance/date-pricing/${enc(date)}`);
  return adminJson(url);
}

export async function financeUpdateDatePricing(date, body) {
  const url = withAdminId(`/admin/finance/date-pricing/${enc(date)}`);
  return adminJson(url, {
    method: "PUT",
    body: JSON.stringify(body || {}),
  });
}

export async function financeUpdateDatePricingDates(dates, pricing) {
  const url = withAdminId(`/admin/finance/date-pricing/dates`);
  return adminJson(url, {
    method: "PUT",
    body: JSON.stringify({ dates: dates || [], pricing: pricing || {} }),
  });
}

export async function financeDeleteDatePricing(date) {
  const url = withAdminId(`/admin/finance/date-pricing/${enc(date)}`);
  return adminJson(url, {
    method: "DELETE",
  });
}
